import { PamWebapiService } from './pam-webapi.service';

export const NgProgressiveJackpotsService = {
    async getProgressiveJackpots({
        currencyCode = null,
        languageCode = null,
    }) {
        const apiEndpoint = '/PJP/GetProgressiveJackpots';
        const apiData = {};

        if (currencyCode !== null) {
            apiData.CurrencyCode = currencyCode;
        }
        if (languageCode !== null) {
            apiData.Language = languageCode;
        }

        return PamWebapiService.postRequest(apiEndpoint, apiData);
    }
};
